import { Layout, MTools, Player } from '@/components';
import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.less';
import { RouteComponentProps, withRouter } from 'dva/router';
import { IBoothTemplateData } from '@/models/types/booth';
import { getBoothDetail } from '@/services/api';

interface ICompanyDetailProps {

}

const CompanyDetail: React.FC<ICompanyDetailProps & RouteComponentProps<{ id: string }>> = ({ match }) => {
  const [data, setData] = useState<IBoothTemplateData[]>([]);
  const id = useMemo(() => {
    return (match.params as { id: string }).id;
  }, [match.params]);

  useEffect(() => {
    if (!id) return;
    window._czc?.push(["_trackEvent", 'company', id])
    getBoothDetail(id).then(result => {
      if (result.success) {
        if (result.data.contentH5) {
          setData(JSON.parse(result.data.contentH5));
        }
      } else {
        MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
      }
    });
  }, [id]);

  const list = useMemo(() => {
    return data.map((item, index) => {
      const {
        type, cover, url,
      } = item;
      let content = <div />;
      if (type === 'image') {
        content = <img src={url} alt="" />;
      }
      if (type === 'video') {
        content = (
          <div className={styles.video}>
            <div className={styles.videoContent}>
              <Player
                url={item.url}
                poster={cover}
              ></Player>
            </div>
          </div>
        );
      }
      return <div key={item.id}>{content}</div>;
    })
  }, [data]);

  return (
    <div className={styles.detail}>
      <Layout
        padding={38}
        share
        businessType={3}
        businessId={id}
        shareStyle={{
          paddingRight: 26,
        }}
      >
        <div className={styles.list}>
          {list}
        </div>
      </Layout>
    </div>
  );
};

export default withRouter(CompanyDetail);
